// pdf.xtract.bot — the hosted editor.
//
// This site exists to satisfy two things at once: a place where anyone
// can use the editor, and a public deployment of the program whose
// source we are obliged (AGPL-3.0-or-later, via MuPDF) to offer. It is
// deliberately tiny — the header below and the <PdfEditor /> component
// with no props — so what runs here and what the npm package ships are
// the same code.

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { PdfEditor } from "@xtract-bot/pdf-editor";
import "./site.css";

const SOURCE_URL = "https://github.com/ryan-dutton/pdf-editor";

function Header() {
  return (
    <header className="flex shrink-0 items-center justify-between gap-4 border-b border-[color:var(--color-border)] px-4 py-1.5 text-sm">
      <div className="flex items-center gap-3">
        <a href="/" className="flex items-center gap-2 font-semibold">
          <i className="ri-edit-2-line text-[color:var(--color-accent)]" aria-hidden />
          PDF Editor
        </a>
        <span className="hidden text-[color:var(--color-fg-muted)] sm:inline">
          Runs in your browser. Nothing is uploaded.
        </span>
      </div>
      <nav className="flex items-center gap-4 text-[color:var(--color-fg-muted)]">
        <a href={SOURCE_URL} className="hover:text-[color:var(--color-fg)]" rel="noopener">
          <i className="ri-github-line mr-1" aria-hidden />
          Source · AGPL-3.0
        </a>
        <a href="https://xtract.bot/apps/pdf-tools" className="hover:text-[color:var(--color-fg)]">
          More PDF tools
        </a>
        <a href="https://xtract.bot" className="hover:text-[color:var(--color-fg)]">
          xtract.bot
        </a>
      </nav>
    </header>
  );
}

function App() {
  return (
    <>
      <Header />
      <main className="min-h-0 w-full flex-1">
        <PdfEditor />
      </main>
    </>
  );
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
